<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">{{ config.data.header }}</span>
      <span class="text-light-color text-base font-normal">#{{ config.data.blueprintSheetData.Id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<app-tabs [initialTabIndex]="0">
  <app-tab tabTitle="Basic Details">
    <div class="flex gap-spacing-xl flex-column">
      @if (appSettings.viewBPSheetDetails) {
        <div class="table-section">
          <h6 class="text-base">Details</h6>

          <div class="details-card border-1 border-round-lg overflow-hidden border-neutral-base-primary-border">
            <div class="item-row grid grid-nogutter">
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Type</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">
                  {{ config.data.blueprintSheetData.Type }}
                </div>
              </div>
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Period</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">
                  {{ config.data.blueprintSheetData.Period }}
                </div>
              </div>
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Duration</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">{{ config.data.blueprintSheetData.DurationInMinutes }} mins ({{ config.data.blueprintSheetData.DistanceInMiles }} mi)</div>
              </div>
            </div>
            <div class="item-row grid grid-nogutter">
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Service</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">
                  {{ config.data.blueprintSheetData.VehicleTypeName }}
                </div>
              </div>
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Student(s)</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">
                  {{ config.data.blueprintSheetData.NumberOfCargo }}
                </div>
              </div>
              <div class="item col-12 md:col-4">
                <div class="item-head py-spacing-xs px-spacing-3xl border-bottom-1 border-neutral-base-primary-border">Monitor(s)</div>
                <div class="item-body py-spacing-xs px-spacing-3xl">
                  {{ config.data.blueprintSheetData.NumberOfAttendants }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (appSettings.viewBPSheetStops) {
        <div class="stops-section">
          <div class="flex justify-content-between align-items-center mb-spacing-xs">
            <h6 class="text-base mb-0">Stops</h6>
            <div class="actions flex">
              <button
                (click)="expandAll()"
                class="text-sm font-medium border-none bg-transparent text-link-color pr-spacing-md border-right-1 border-neutral-base-primary-border">
                Expand All
              </button>
              <button
                (click)="openMapDialog()"
                class="text-sm font-medium border-none bg-transparent text-link-color pl-spacing-md">
                <i class="icon-map-trifold-solid"></i> View Map
              </button>
            </div>
          </div>

          <p-accordion
            class="w-full"
            [multiple]="true"
            (valueChange)="accordionActiveIndexChange($event)"
            [value]="accordionActiveIndex">
            @for (stop of config.data.blueprintSheetData.Waypoints; let i = $index; track $index) {
              <p-accordion-panel
                [value]="i"
                class="p-accordion-tab-element">
                <p-accordion-header>
                  <div
                    class="header-wrapper w-full"
                    (click)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()">
                    <div
                      [ngClass]="{ open: accordionActiveIndex.includes(i) }"
                      class="stop w-full flex justify-content-between gap-spacing-xl align-items-start">
                      <div class="left flex flex-grow-1 gap-spacing-md align-items-start">
                        <div class="time flex flex-column align-items-center gap-spacing-default">
                          <span class="text-base font-medium text-secondary-color">{{ stop.ScheduledArrivalTime }}</span>
                          <span class="text-sm font-medium text-lightest-color min-w-max">{{ config.data.rideTimezone }}</span>
                        </div>
                        <div class="badge-container relative">
                          <app-badge
                            [value]="(i + 1).toString()"
                            size="xlarge"
                            severityClass="info"></app-badge>
                          <span class="h-line"></span>
                        </div>

                        <div class="location flex flex-column gap-spacing-default border-1 border-neutral-base-primary-border border-round-lg bg-white w-full py-spacing-xs px-spacing-md">
                          <div class="place flex align-items-center gap-spacing-xs">
                            @if (stop.Type == stopPlaceType().School) {
                              <i class="icon-building-office-solid text-base text-lightest-color"></i>
                            } @else {
                              <img
                                src="assets/images/house-5 1.svg"
                                alt="" />
                            }
                            <span class="name text-base font-medium text-secondary-color">{{ stop.Name }}</span>
                          </div>
                          <div class="map-location flex align-items-center gap-spacing-xs">
                            <i class="icon-map-pin-solid text-base text-link-color"></i>
                            <a class="link no-underline text-base font-normal text-link-color">
                              {{ stop.FullAddress }}
                            </a>
                          </div>
                        </div>
                      </div>

                      <div class="right flex justify-content-between align-items-center">
                        <div class="action-btns flex gap-spacing-xs align-items-center">
                          <app-button
                            [ngClass]="{ 'accordion-btn-active': accordionActiveIndex.includes(i) }"
                            (btnClick)="toggleActiveAccordionTab($index)"
                            [iconOnlyButton]="true"
                            [icon]="accordionActiveIndex.includes($index) ? 'icon-caret-up' : 'icon-caret-down'"
                            sizeClass="p-button-sm"
                            severity="primary"
                            [outlinedButton]="true"></app-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="content relative">
                    <span class="h-line"></span>
                    <hr class="mb-spacing-md mt-0 opacity-100 border-neutral-base-primary-border" />
                    <div class="passengers mb-spacing-md py-spacing-xs px-spacing-md border-1 border-neutral-base-primary-border bg-white border-round-md">
                      <h6 class="text-base font-medium mb-spacing-default text-secondary-color">Passengers</h6>
                      <div class="grid grid-nogutter gap-spacing-xs">
                        @for (passenger of stop.Cargo; track $index) {
                          <div class="passenger w-full bg-white flex justify-content-between gap-spacing-xs">
                            <div class="left flex align-items-center gap-spacing-xs">
                              @if (stop.ActionType.toLowerCase() == cargoActionType().PickUp.toLowerCase()) {
                                <img
                                  src="assets/images/person-plus-fill 1.svg"
                                  alt="" />
                              } @else if (stop.ActionType.toLowerCase() == cargoActionType().DropOff.toLowerCase()) {
                                <img
                                  src="assets/images/person-dash-fill 1.svg"
                                  alt="" />
                              }
                              <span class="name text-base font-medium line-height-3 text-secondary-color">{{ passenger.Name }}</span>
                              <span class="text-sm form-border-hover-color px-spacing-default border-1 form-border-default-border line-height-2 border-round">
                                {{ passenger.CargoType }}
                              </span>
                              @if (currentRole !== userRole.Provider) {
                                @if (passenger.CargoType?.toLowerCase() == "student") {
                                  <i
                                    class="text-lg"
                                    [pTooltip]="passenger.isTransportationConfirmed ? 'Transportaion Confirmed' : 'Needs Confirmation'"
                                    tooltipPosition="right"
                                    [autoHide]="false"
                                    [ngClass]="{
                                      'icon-check-circle-solid icon-success-subtle-color': passenger.isTransportationConfirmed,
                                      'icon-question-solid icon-warning-color': !passenger.isTransportationConfirmed
                                    }"></i>
                                }
                              }
                            </div>

                            <div class="right flex justify-content-between align-items-center">
                              <app-tag
                                [content]="stop.ActionType"
                                sizeClass="tag-sm"
                                severityClass="secondary"></app-tag>
                            </div>
                          </div>
                        }
                      </div>
                    </div>

                    <div class="grid flex-column lg:flex-row">
                      <div class="col-12 lg:col-6">
                        <div class="adjustments h-full py-spacing-xs px-spacing-md border-1 border-neutral-base-primary-border bg-white border-round-md">
                          <h6 class="text-base font-medium mb-spacing-default text-secondary-color">Weekly Schedule Adjustments</h6>
                          <ul class="mb-0 pl-spacing-2xl">
                            @if (stop.weeklyAdjustments) {
                              <li class="text-sm text-lightest-color">{{ stop.weeklyAdjustments }}</li>
                            } @else {
                              <li class="text-sm text-lightest-color">N/A</li>
                            }
                          </ul>
                        </div>
                      </div>
                      <div class="col-12 lg:col-6">
                        <div class="instructions h-full py-spacing-xs px-spacing-md border-1 border-neutral-base-primary-border bg-white border-round-md">
                          <h6 class="text-base font-medium mb-spacing-default text-secondary-color">Place Instructions</h6>
                          <ul class="mb-0 pl-spacing-2xl">
                            @if (stop.ActionType.toLowerCase() == "pick-up" && stop!.ExternalPickUpNote) {
                              <li class="text-sm text-lightest-color">
                                {{ stop.ExternalPickUpNote }}
                              </li>
                            } @else if (stop.ActionType.toLowerCase() == "drop-off" && stop!.ExternalDropOffNote) {
                              <li class="text-sm text-lightest-color">
                                {{ stop.ExternalDropOffNote }}
                              </li>
                            } @else {
                              <li class="text-sm text-lightest-color">N/A</li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      }

      @if (appSettings.viewBPSheetEquipment) {
        <div class="table-section">
          <h6 class="text-base">Equipments</h6>
          @if (equipments.length > 0) {
            <app-basic-table [tableData]="equipments | basicTable"></app-basic-table>
          } @else {
            <app-data-not-found field="equipments"></app-data-not-found>
          }
        </div>
      }

      @if (appSettings.viewBPSheetClanedars) {
        <div class="table-section">
          <h6 class="text-base">Calendars</h6>
          @if (calenders.length > 0) {
            <app-basic-table [tableData]="calenders | basicTable"></app-basic-table>
          } @else {
            <app-data-not-found field="calendars"></app-data-not-found>
          }
        </div>
      }
    </div>
  </app-tab>

  <app-tab tabTitle="Client & Passengers">
    <div class="flex gap-spacing-xl flex-column">
      @if (appSettings.viewClientContacts) {
        <div class="table-section">
          <h6 class="text-base">Client Contacts</h6>
          @if (clientContacts.length > 0) {
            <app-basic-table
              [showIndex]="true"
              [tableData]="clientContacts | basicTable"></app-basic-table>
          } @else {
            <app-data-not-found field="clientContacts"></app-data-not-found>
          }
        </div>
      }

      @if (appSettings.viewDestinationTable) {
        <div class="table-section">
          <h6 class="text-base">Destination</h6>
          @if (destinations.length > 0) {
            <app-basic-table
              [showIndex]="true"
              [tableData]="destinations | basicTable"></app-basic-table>
          } @else {
            <app-data-not-found field="destination"></app-data-not-found>
          }
        </div>
      }

      @if (appSettings.viewStudentsTable) {
        <div class="table-section">
          <h6 class="text-base">Students</h6>
          @if (students.length > 0) {
            <app-basic-table
              [showIndex]="true"
              [tableData]="students | basicTable: 'students'"
              [tableName]="'students'"></app-basic-table>
          } @else {
            <app-data-not-found field="students"></app-data-not-found>
          }
        </div>
      }
    </div>
  </app-tab>

  @if (appSettings.viewPaymentDetails) {
    <app-tab tabTitle="Payments Details">
      <h6 class="text-base">Payout</h6>
      <div class="bg-white border-1 border-neutral-base-primary-border border-round-lg p-spacing-xl">
        <div class="inputs flex-column md:flex-row flex gap-spacing-xl">
          <div class="form-group flex-grow-1">
            <label
              class="input-label mb-spacing-xs flex gap-spacing-default align-items-center"
              for="serviceProviderPay"
              >Service Provider Total Pay
              <i
                [pTooltip]="serviceProviderPayTooltip"
                tooltipPosition="bottom"
                [autoHide]="false"
                class="text-lightest-color icon-info-solid text-xl"></i>
              <ng-template #serviceProviderPayTooltip>
                <div class="tooltip-head">
                  <span class="title">Service Provider Total Payout Details</span>
                </div>
                <div class="tooltip-body">
                  @for (day of config.data.blueprintSheetData?.AssignmentDetails; track $index) {
                    <div class="item flex-row justify-content-between">
                      <span class="border-neutral-base-primary-color">{{ day.DayName }}</span>
                      <span>${{ day.ContractorOriginalPayout + day.PayoutsAdjustments | number: "1.2-2" }}</span>
                    </div>
                  }
                </div>
              </ng-template>
            </label>
            <div class="k-input-wrapper">
              <em class="left-icon icon-currency-dollar"></em>
              <input
                id="serviceProviderPay"
                class="p-inputtext-base"
                type="text"
                placeholder="Service Provider Total Pay"
                pInputText
                readonly
                [(ngModel)]="serviceProviderPay" />
            </div>
          </div>
          <div class="form-group flex-grow-1">
            <label
              class="input-label mb-spacing-xs flex gap-spacing-default align-items-center"
              for="driverProviderPay"
              >Driver Total Pay
              <i
                [pTooltip]="driverProviderPayTooltip"
                tooltipPosition="bottom"
                [autoHide]="false"
                class="text-lightest-color icon-info-solid text-xl"></i>
              <ng-template #driverProviderPayTooltip>
                <div class="tooltip-head">
                  <span class="title">Driver Provider Total Payout Details</span>
                </div>
                <div class="tooltip-body">
                  @for (day of config.data.blueprintSheetData?.AssignmentDetails; track $index) {
                    <div class="item flex-row justify-content-between">
                      <span class="border-neutral-base-primary-color">{{ day.DayName }}</span>
                      <span>${{ day | calcDriverPayoutSheet | number: "1.2-2" }}</span>
                    </div>
                  }
                </div>
              </ng-template>
            </label>

            <div class="k-input-wrapper">
              <em class="left-icon icon-currency-dollar"></em>
              <input
                id="driverProviderPay"
                class="p-inputtext-base"
                type="text"
                placeholder="Driver Provider Total Pay"
                pInputText
                readonly
                [(ngModel)]="driverProvidePay" />
            </div>
          </div>
        </div>
        <div class="flex gap-spacing-xs mt-spacing-xs">
          <i
            class="icon-info icon-light-color position-relative"
            style="top: 2px"></i>
          <p class="mb-0 form-placeholder-color text-sm">These numbers are for the first week day and without any adjustment, Click on Info icon to see all days payouts with adjustments.</p>
        </div>
      </div>
    </app-tab>
  }

  @if (appSettings.viewPlaceInstructions) {
    <app-tab tabTitle="Place Instructions">
      <div class="flex gap-spacing-xl flex-column">
        <div class="table-section">
          <h6 class="text-base">Instructions Details</h6>
          @if (placeInstructions.length > 0) {
            <app-basic-table
              [showIndex]="true"
              [tableData]="placeInstructions | basicTable"></app-basic-table>
          } @else {
            <app-data-not-found field="instructions"></app-data-not-found>
          }
        </div>
      </div>
    </app-tab>
  }

  @if (currentRole == userRole.Provider) {
    <app-tab tabTitle="Instructions">
      <div class="flex gap-spacing-xl flex-column">
        @if (studentInstructions.length > 0) {
          <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs">
            <i class="icon-warning-solid text-xl icon-warning-color"></i>
            <ul class="mb-0 pl-spacing-2xs list-none">
              <li class="label-large-regular text-warning-color">Please review all instructions carefully before starting the ride. Contact dispatch if you have any questions or concerns about these requirements.</li>
            </ul>
          </div>

          <div class="instructions-accordion-section">
            <p-accordion
              class="w-full"
              expandIcon="pi pi-plus"
              collapseIcon="pi pi-minus">
              @for (s of studentInstructions; track $index) {
                <p-accordion-panel
                  [value]="$index"
                  class="student-instruction-custom-accordion">
                  <p-accordion-header>
                    <div class="flex justify-content-between gap-spacing-xs align-items-center w-full">
                      <h6 class="m-0 body-medium-bold text-secondary-color">{{ s.fullName }}</h6>
                      <i class="icon-caret-down size-icon-md"></i>
                    </div>
                  </p-accordion-header>
                  <p-accordion-content>
                    <div class="requirements">
                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-eye size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Monitor Requirements</h5>
                        </div>
                        <div class="requirement-content p-spacing-xl">
                          <div class="grid">
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Monitor Type</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                {{ s.needsClientProvidedAttendant ? "Client Monitor" : s.needsPlatformProvidedAttendant ? "ADROIT Monitor" : "Not Required" }}
                              </span>
                            </div>
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Preferred Monitor Gender</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">{{ s.preferredAttendantSex || "No Preference" }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-car size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Driver Requirements</h5>
                        </div>
                        <div class="requirement-content p-spacing-xl">
                          <div class="grid">
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Sensitive Ride</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                {{ s.isSensitiveRide ? "Yes" : "No" }}
                              </span>
                            </div>
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Preferred Driver Gender</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                {{ s.preferredDriverGender }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-toolbox size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Transportation Requirements</h5>
                        </div>
                        <div class="requirement-content p-spacing-xl">
                          <div class="grid">
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Solo Rider</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                {{ s.isSoloRider ? "Yes" : "No" }}
                              </span>
                            </div>
                            <div class="item col-6 flex flex-column gap-spacing-2xs">
                              <h6 class="item-label m-0 label-large-medium text-primary-color">Wheelchair Required</h6>
                              <span class="item-value align-content-center h-2rem px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                {{ s.needsWheelchairVehicle ? "Yes" : "No" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-map-pin-simple-area size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Place Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          <div class="item col-12 flex flex-column gap-spacing-2xs">
                            <h6 class="item-label m-0 label-large-medium text-primary-color">Pick up</h6>
                            <span
                              [ngClass]="{ 'opacity-50': !s.placeInstructions.pickUpInstruction }"
                              class="item-value align-content-center py-spacing-2xs px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                              {{ s.placeInstructions.pickUpInstruction || "No Instructions" }}
                            </span>
                          </div>
                          <div class="item col-12 flex flex-column gap-spacing-2xs">
                            <h6 class="item-label m-0 label-large-medium text-primary-color">DropOff</h6>
                            <span
                              [ngClass]="{ 'opacity-50': !s.placeInstructions.dropOffInstruction }"
                              class="item-value align-content-center py-spacing-2xs px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                              {{ s.placeInstructions.dropOffInstruction || "No Instructions" }}
                            </span>
                          </div>
                          <div class="item col-12 flex flex-column gap-spacing-2xs">
                            <h6 class="item-label m-0 label-large-medium text-primary-color">Other Instruction</h6>
                            @if (s.placeInstructions.otherInstructions.length == 0) {
                              <span class="opacity-50 item-value align-content-center py-spacing-2xs px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md"> No Instructions </span>
                            } @else {
                              <div class="flex flex-column gap-spacing-xs">
                                @for (inst of s.placeInstructions.otherInstructions; track $index) {
                                  <span class="item-value align-content-center py-spacing-2xs px-spacing-md form-bg-disabled-bg border-1 border-neutral-base-primary-border radius-md">
                                    {{ inst }}
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-arrow-up-right size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Pick-up Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          @if (s.pickupInstructionsNote) {
                            <p class="m-0 p-spacing-md border-1 border-neutral-base-primary-border radius-lg">
                              {{ s.pickupInstructionsNote }}
                            </p>
                          } @else {
                            <span class="label-large-regular text-caption-color">No Instructions</span>
                          }
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-seat-belt size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">On Board Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          @if (s.onboardInstructionsNote) {
                            <p class="m-0 p-spacing-md border-1 border-neutral-base-primary-border radius-lg">
                              {{ s.onboardInstructionsNote }}
                            </p>
                          } @else {
                            <span class="label-large-regular text-caption-color">No Instructions</span>
                          }
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-arrow-down-right size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Drop Off Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          @if (s.dropOffInstructionsNote) {
                            <p class="m-0 p-spacing-md border-1 border-neutral-base-primary-border radius-lg">
                              {{ s.dropOffInstructionsNote }}
                            </p>
                          } @else {
                            <span class="label-large-regular text-caption-color">No Instructions</span>
                          }
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-question size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Special Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          @if (s.specialInstructionsNote) {
                            <p class="m-0 p-spacing-md border-1 border-neutral-base-primary-border radius-lg">
                              {{ s.specialInstructionsNote }}
                            </p>
                          } @else {
                            <span class="label-large-regular text-caption-color">No Instructions</span>
                          }
                        </div>
                      </div>

                      <div class="requirement-section">
                        <div class="requirement-header background-surface-neutral-l1-bg flex align-items-center gap-spacing-sm py-spacing-xs px-spacing-xl">
                          <i class="icon-file-text size-icon-md icon-link-color"></i>
                          <h5 class="m-0 body-medium-medium text-secondary-color">Other Instructions</h5>
                        </div>
                        <div class="requirement-content flex flex-column gap-spacing-xs p-spacing-xl">
                          @if (s.otherInstructionsNote.length > 0) {
                            @for (inst of s.otherInstructionsNote; track $index) {
                              <p class="m-0 p-spacing-md border-1 border-neutral-base-primary-border radius-lg">
                                {{ inst }}
                              </p>
                            }
                          } @else {
                            <span class="label-large-regular text-caption-color">No Instructions</span>
                          }
                        </div>
                      </div>
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-data-not-found field="instructions"></app-data-not-found>
        }
      </div>
    </app-tab>
  }
</app-tabs>

<hr class="-mx-spacing-3xl border-neutral-base-primary-color opacity-100 mb-0" />
<div class="p-dialog-footer pt-spacing-3xl px-0">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
